import React, { Component } from "react";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import { momentModule } from "../../utils/Utils";

import "../../../styles/components/chargers/modals/SetPurchaseTariffPlan.scss";

const { moment, formatDate } = momentModule;

class SetPurchaseTariffPlan extends Component {
  render() {
    return (
      <>
        <Modal
          id="setPurchaseTariffPlan"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.reset}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <Translate value="purchaseTariffs_setValue" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form id="set-purchase-tariff-plan-form" onSubmit={this.props.onSubmit}>
              <Form.Group className="form-field">
                <Form.Label>
                  <p className="date">{moment().day(this.props.weekDayIdx)?.format?.("dddd")}</p>
                  <p className="time-span">{`${formatDate(
                    this.props.startTime,
                    "time"
                  )} - ${formatDate(this.props.stopTime, "time")}`}</p>
                </Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  step="0.0001"
                  defaultValue={this.props.value}
                  name="planValue"
                  placeholder="0.09"
                  onKeyDown={e =>
                    (e.key === "e" || e.key === "+" || e.key === "-") && e.preventDefault()
                  }
                  required
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="set-purchase-tariff-plan-form">
              <Translate value="general_save" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default SetPurchaseTariffPlan;
